document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-z-open-fit]');
  if (!link) return;
  const details = document.getElementById('fit-guide');
  if (!(details instanceof HTMLDetailsElement)) return;
  event.preventDefault();
  details.open = true;
  details.querySelector('summary')?.focus({ preventScroll: true });
  details.scrollIntoView({ behavior: 'auto', block: 'center' });
});
const headerMenus = '.z-mobile-menu, .z-shop-menu, .z-region-menu';
document.addEventListener('click', (event) => {
  for (const menu of document.querySelectorAll(headerMenus)) {
    if (menu.open && (!menu.contains(event.target) || event.target.closest('a'))) menu.open = false;
  }
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  for (const menu of document.querySelectorAll(headerMenus)) {
    if (!menu.open) continue;
    menu.open = false;
    menu.querySelector('summary')?.focus();
  }
});
